import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=aa37f6fe"
import script from "./NewsContent.vue?vue&type=script&lang=ts"
export * from "./NewsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports